import ajaxFetch from "@/js/fn/ajax-fetch";

/** Émis par le bouton de publication tout juste rendu, qui porte son état dans `data-published`. */
export const PUBLISHED_TOGGLED = "published:toggled";

export default function initToggle(): void {
    document.body.addEventListener("click", e => {
        const el = (e.target as HTMLElement).closest<HTMLButtonElement>("button[data-toggle-url]");
        if (!el) {
            return;
        }

        e.preventDefault();
        const url = el.dataset.toggleUrl!;
        ajaxFetch(url)
            .then(async response => ({ ok: response.ok, body: await response.text() }))
            .then(({ ok, body }) => {
                // La réponse remplace la ligne du tableau : n'y injecter que ce que le
                // contrôleur a rendu. Sur un refus (voter, CSRF invalide) ou une erreur
                // serveur, le corps est une page d'erreur entière — le bouton reste en
                // place plutôt que de la coller dans la cellule.
                if (!ok) {
                    return;
                }

                const template = document.createElement("template");
                template.innerHTML = body;
                const replacement = template.content.firstElementChild;
                el.replaceWith(template.content);
                replacement?.dispatchEvent(new CustomEvent(PUBLISHED_TOGGLED, { bubbles: true }));
            });
    });
}
